<template>
  <div class="collapsed-widget" @click="toggleCollapsed">
    <div class="avatar-container">
      <img
        v-if="getAvatar"
        class="avatar"
        :src="getAvatar.thumbnail_image"
        alt="thumbnail"
      />
      <span class="status" v-if="getAvatar"></span>
    </div>
    <h3 class="header">MESSAGES</h3>
    <span class="unread" v-if="totalUnreadMessages">
      {{ totalUnreadMessages }}
    </span>
    <img
      class="minimize"
      src="@/assets/images/icons/minimize-grey.svg"
      alt="minimize"
      v-show="!collapsed"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex"
export default {
  computed: {
    ...mapGetters("User/Profile", ["getAvatar"]),
    ...mapGetters("Message", ["totalUnreadMessages", "collapsed"]),
  },
  methods: {
    ...mapActions("Message", ["checkTotalUnread"]),
    ...mapMutations("Message", ["setCollapsed"]),
    toggleCollapsed () {
      this.setCollapsed(!this.collapsed)
    },
  },
  mounted () {
    this.checkTotalUnread()
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
@import "@/assets/style/_variables.scss";
.collapsed-widget {
  background-color: #18181b;
  cursor: pointer;
  width: 26rem;
  height: 5.5rem;
  border-radius: 8px 8px 0 0;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  border: 1px solid #3d4049;
  border-bottom: none;
  @include tablet-down {
    width: 100%;
  }

  .avatar-container {
    position: relative;
    .avatar {
      width: 3rem;
      border-radius: 50%;
    }
    .status {
      background-color: #76c800;
      border: 2px solid #18181b;
      border-radius: 50%;
      position: absolute;
      right: -0.2rem;
      bottom: 0.2rem;
      width: 1.2rem;
      height: 1.2rem;
    }
  }
  .header {
    font-family: $font-display;
    color: #fff;
    font-weight: 600;
    font-size: 1.8rem;
    margin-left: 2rem;
  }
  .unread {
    margin-left: 1rem;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    background-color: #f14950;
    font-family: $font-display;
    font-weight: 600;
    font-size: 1.4rem;
    line-height: 100%;
    color: #fff;
    text-align: center;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .minimize {
    margin-left: auto;
    border-radius: 50%;
    height: 3.5rem;
    width: 3.5rem;
    padding: 0 1rem;
    transition: all 0.1s;
    &:hover {
      background-color: rgba(255, 255, 255, 0.05);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/message_widget/CollapsedWidget.vue